module.exports = __webpack_public_path__ + "img/profile-icon.20bc458d.png";